import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPage from "../pages/blog/page";
import BlogDetail from "../pages/blog/components/BlogDetail";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import ContactPage from "../pages/contact/page";
import { HOME_SECTION_IDS } from "@/constants/homeSections";

const homeSectionRoutes: RouteObject[] = HOME_SECTION_IDS.map((sectionId) => ({
  path: `/${sectionId}`,
  element: <Home />,
}));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...homeSectionRoutes,
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
